import { useEffect, useState } from "react";

import { Avatar, type AvatarProps } from "@mui/material";

import { fetchPractitionerPhoto } from "@/api/profile";

function initials(name: string): string {
  const parts = name.trim().split(/\s+/);
  if (parts.length >= 2) {
    return ((parts[0]?.[0] ?? "") + (parts[parts.length - 1]?.[0] ?? "")).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
}

type Props = AvatarProps & {
  practitionerId: string;
  hasPhoto: boolean;
  displayName: string;
  cacheBust?: string | number;
};

export function PractitionerAvatar({
  practitionerId,
  hasPhoto,
  displayName,
  cacheBust,
  sx,
  ...rest
}: Props) {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!hasPhoto) {
      setUrl(null);
      return;
    }
    let revoke: string | null = null;
    fetchPractitionerPhoto(practitionerId).then((blob) => {
      if (blob) {
        const objectUrl = URL.createObjectURL(blob);
        revoke = objectUrl;
        setUrl(objectUrl);
      }
    });
    return () => {
      if (revoke) URL.revokeObjectURL(revoke);
      setUrl(null);
    };
  }, [practitionerId, hasPhoto, cacheBust]);

  return (
    <Avatar
      src={url ?? undefined}
      alt={displayName}
      sx={{ bgcolor: "primary.main", fontWeight: 700, ...sx }}
      {...rest}
    >
      {!url && initials(displayName)}
    </Avatar>
  );
}
